import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface CopyModeBannerProps {
  step: 'source' | 'target';
  sourceLabel?: string;
  scheduleCount: number;
  targetCount: number;
  loading: boolean;
  onExecute: () => void;
  onCancel: () => void;
}

/**
 * 복사 모드 상단 올인원 컨트롤.
 * 단계 안내 + (대상 선택 단계에서) '복사 실행' 버튼 + '복사 취소'를
 * 한 줄(작은 화면에선 세로)에 모아 달력이 커도 흐름이 상단에서 끝나게 한다.
 */
const CopyModeBanner: React.FC<CopyModeBannerProps> = ({
  step,
  sourceLabel,
  scheduleCount,
  targetCount,
  loading,
  onExecute,
  onCancel,
}) => {
  const message =
    step === 'source'
      ? '① 복사할 원본 날짜를 선택하세요'
      : `② 붙여넣을 날짜를 클릭하세요 · 원본: ${sourceLabel} ${scheduleCount}건`;

  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 1.5,
        background: 'var(--primary-soft)',
        border: '1px solid var(--primary)',
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 600, color: 'var(--fg-strong)' }}>
          {message}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        {step === 'target' && (
          <Button
            variant="contained"
            onClick={onExecute}
            disabled={loading || targetCount === 0}
          >
            복사 실행 ({targetCount}일 · {targetCount * scheduleCount}건)
          </Button>
        )}
        <Button
          onClick={onCancel}
          disabled={loading}
          sx={{ color: 'var(--fg-secondary)' }}
        >
          복사 취소
        </Button>
      </Box>
    </Box>
  );
};

export default CopyModeBanner;
